import AttendanceAdapter from './base';

export default class Intervention extends AttendanceAdapter {
  modelNamePlural = 'interventions';
}
